import { defaultValue, makeText, setHtml } from '../lib.js';
import { fadeInTimeoutMS, fadeOut, handleFadeInOut, isClickOutside, isClicked, saveClick } from './utils.js';

const faceRecoDefText = defaultValue(
  `Please upload a selfie, or a good portrait picture of everyone in your party so we can find your images!`
);

let hasShownFaceRecoTooltip = false;

export function show(text) {
  if (!isClicked('faceRecoBtnClicked')) {
    const element = makeText('.faceReco-tooltip__text');
    setHtml(faceRecoDefText(text), element);

    setTimeout(() => handleFadeInOut('.faceReco-tooltip'), fadeInTimeoutMS);

    document.addEventListener('click', (event) => {
      const selectors = ['.top-panel', '.menu', '#qrr-overlay', '#qrr-container', '#customPopUp'];
      if (isClickOutside(event, selectors)) {
        fadeOut('.faceReco-tooltip');
        if (!hasShownFaceRecoTooltip && !isClicked('uploadPhotoBtnClicked')) {
          setTimeout(() => handleFadeInOut('.ugc-tooltip'), fadeInTimeoutMS);
          hasShownFaceRecoTooltip = true;
        }
      }
    });

    document.querySelector('.add-selfie__btn').addEventListener('click', Off);
  }
}

export function Off() {
  saveClick('faceRecoBtnClicked');
  fadeOut('.faceReco-tooltip');
}
